import React from "react";
import { useSelector } from "react-redux";
import "./appointmentStats.scss";
import { trackShipmentSelector } from "../../../../../slices/track-shipment/trackShipmentSlice";
import Loading from "../../../../../ui-components/loading/loading";
import { ReactComponent as CalendarIcon } from "../../../../../images/calendar-dots_blue.svg";

export const AppointmentStats: React.FC<{onAppointmentPendingChanged: any}> = (props) => {
  const trackShipmentState = useSelector(trackShipmentSelector);

  return (
    <div className="xgs-appointment-stats">
      {trackShipmentState.loadingStats && <Loading isLoading/>}
      {trackShipmentState.loadingStatsFailed && (
        <div>{trackShipmentState.loadingStatsError}</div>
      )}
      {trackShipmentState.loadedStats && trackShipmentState.stats && <>
        <div className="xgs-appointment-stats__block">
          <div onClick={() => props.onAppointmentPendingChanged(false)} className="xgs-appointment-stats__icon xgs-appointment-stats__icon--blue">
            <CalendarIcon />
          </div>
          <div className="xgs-appointment-stats__value">{trackShipmentState.stats.appointmentRequired}</div>
          <div className="xgs-appointment-stats__text">
            Probills with appointment required
          </div>
        </div>
        <div className="xgs-appointment-stats__block">
          <div onClick={() => props.onAppointmentPendingChanged(true)} className="xgs-appointment-stats__icon xgs-appointment-stats__icon--red">
            <CalendarIcon />
          </div>
          <div className="xgs-appointment-stats__value">{trackShipmentState.stats.appointmentPending}</div>
          <div className="xgs-appointment-stats__text">
            Appointment needs to be scheduled
          </div>
        </div>
      </>}
    </div>
  )
}